import { render, staticRenderFns } from "./importdata.vue?vue&type=template&id=514359b4&scoped=true&"
import script from "./importdata.vue?vue&type=script&lang=js&"
export * from "./importdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514359b4",
  null
  
)

export default component.exports